module.exports = __webpack_public_path__ + "img/klarna-ratenkauf.f6ce5d1.svg";